<template>
  <div>
    <div class="cid-head">
      <div class="cid-head-head">
        <div class="cid-head-head-left">
          <img :src="img" @click="goBack()"/>
        </div>
        <input :placeholder="inputPlaceholder" @click="goToSearch()"/>
      </div>
      <div class="cid-head-foot">
        <ul class="menu">
          <li @click="handleOne(0,'')" id="0"><a :class="classArray[0]">全部</a></li>
          <li @click="handleOne(1,'t=1')" id="1"><a :class="classArray[1]">女装</a></li>
          <li @click="handleOne(9,'t=9')" id="9"><a :class="classArray[9]">男装</a></li>
          <li @click="handleOne(10,'t=10')" id="10"><a :class="classArray[10]">内衣</a></li>
          <li @click="handleOne(2,'t=2')" id="2"><a :class="classArray[2]">母婴</a></li>
          <li @click="handleOne(3,'t=3')" id="3"><a :class="classArray[3]">化妆</a></li>
          <li @click="handleOne(4,'t=4')" id="4"><a :class="classArray[4]">居家</a></li>
          <li @click="handleOne(5,'t=5')" id="5"><a :class="classArray[5]">鞋包</a></li>
          <li @click="handleOne(6,'t=6')" id="6"><a :class="classArray[6]">美食</a></li>
          <li @click="handleOne(7,'t=7')" id="7"><a :class="classArray[7]">文体</a></li>
          <li @click="handleOne(8,'t=8')" id="8"><a :class="classArray[8]">数码</a></li>
        </ul>
      </div>
      <div id="cid"></div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'CidHeader',
    props:['cid'],
    data(){
      return{
        active:'active',
        classArray:[
          '','','','','','','','','','',''
        ],
        img:require("../../../static/img/H5_home_white.png"),
        inputPlaceholder: "输入京东/拼多多商品名称或关键字"
      }
    },
    created(){
      !this.isWeixin && (this.inputPlaceholder = "输入淘宝/天猫/京东/拼多多商品名称或关键字")
    },
    mounted(){
      if(this.isIos){
        document.getElementsByClassName("cid-head-head-left")[0].style.marginTop='0.5rem';
      }
      let seft = this;
      this.moveToBar();
      this.classArray = this.classArray.map(function(item,index,array){
        if(seft.cid==index){
          return seft.active;
        }else{
          return '';
        }
      });
    },
    methods:{
      handleClass(idx){
        let seft = this;
        this.classArray = this.classArray.map(function(item,index,array){
          if(idx==index){
            return seft.active;
          }else{
            return '';
          }
        });
        console.log(this.classArray);
      },
      handleOne(idx,param){
        window.location.hash = "recommend?headType=3";
        this.handleClass(idx);
        this.public.cidParam = param;
        console.log(this.public.cidParam);
        this.public.toggleResert();
        this.public.toggleReload();
      },
      goToSearch(){
        this.jumpToView(this.headType.searchHead)
      },
      goBack(){
        window.history.back();
      },
      moveToBar(){
        let inner = window.innerWidth/2;
        let offetLeft = document.getElementById(this.cid).offsetLeft;
        if(offetLeft>=inner){
          document.getElementsByClassName("menu")[0].scrollLeft = offetLeft-inner;
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// CidHeader.vue?5dfbd00f